import barberShop from '@/assets/img/users-cases/barber-shop.webp';
import barberShopHow from '@/assets/img/users-cases/barber-shop-how.webp';
import barberShopResult from '@/assets/img/users-cases/barber-shop-result.webp';

export default {
  slug: 'barber-shop',
  order: 12,
  title: '360 Tour Barbershop',
  subtitle: 'Compact interior renderings with realistic materials',
  tags: ['barbershopdesign', 'barbershoplayouts'],

  images: {
    hero: barberShop,
    aboutTop: barberShopHow,
    aboutBottom: barberShopResult,
  },

  howText:
    'We designed barbershop floor plan, 2D and 3D layouts, and interior design for barbershop with optimized routes, aesthetics, and ergonomics.',

  resultText:
    'Clients receive ready-to-use visualizations and plans for presentations, marketing, and opening barbershops efficiently.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
